import type { ReactNode } from 'react';
import cx from 'clsx';

import styles from './AiChip.module.css';

export type AiChipSize = 'tiny' | 'small' | 'medium' | 'large';

/**
 * Color treatment of a chip. Named after — and styled with the same tokens as — the equivalent
 * variants of the Launchpad `Tag` component, so a chip reads the same as a tag beside it.
 */
export type AiChipVariant = 'default' | 'info' | 'beta';

/**
 * Inline chip used for short read-only labels in AI Configs surfaces (config mode, evaluator kind).
 * Presentation only — callers supply the label, pick a size to match the surrounding text, and pick
 * a variant to distinguish categories of label.
 *
 * Intentionally not a Launchpad `Tag`: `Tag` requires a `TagGroup` > `TagList` wrapper per instance,
 * which is more machinery than a static label needs inside a dense list row or table cell.
 */
export function AiChip({
  size = 'medium',
  variant = 'default',
  className,
  children,
}: {
  size?: AiChipSize;
  variant?: AiChipVariant;
  className?: string;
  children: ReactNode;
}) {
  return <span className={cx(styles.chip, styles[size], styles[variant], className)}>{children}</span>;
}
